import Vue from "vue";
import Router from "vue-router";
import Layout from "@/layout/index.vue";
import layoutScreen from "@/layout/layout-screen.vue";

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

const originReplace = Router.prototype.replace;
Router.prototype.replace = function (location, resolve, reject) {
  if (resolve && reject) {
    originReplace.call(this, location, resolve, reject);
  } else {
    originReplace.call(
      this,
      location,
      () => {},
      () => {}
    );
  }
};

const routes = [
  {
    path: "/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/login/index.vue"),
  },
  {
    path: "/404",
    component: () => import("@/views/404"),
    hidden: true,
  },
  // {
  //   path: "/",
  //   component: Layout,
  //   redirect: "/home",
  //   children: [
  //     {
  //       path: "/home",
  //       name: "home",
  //       component: () => import("@/views/home/index"),
  //       meta: { title: "欢迎页", icon: "home" },
  //     },
  //   ],
  // },
  {
    path: "/common",
    component: Layout,
    redirect: "/editorOnline",
    children: [
      {
        path: "/common/editorOnline",
        name: "editorOnline",
        component: () => import("@/views/common/editorOnline/index.vue"),
        meta: { title: "在线编辑", icon: "home" },
      },
    ],
  },
  // 温控大屏
  {
    path: "/temperatureLargeScreen",
    name: "temperatureLargeScreen",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "@/views/temperatureLargeScreen/index.vue"
      ),
  },
  {
    path: "/bigScreen",
    component: () => import("@/views/BigScreen/index.vue"),
    props: (route) => ({ current: route.query.current }),
  },
  {
    path: "/dashboard",
    component: layoutScreen,
    redirect: "dashboard-home",
    children: [
      {
        // 主页
        path: "/dashboard/home",
        component: () => import("@/views/dashboard/home/index.vue"),
        name: "dashboard-home",
        meta: { title: "主页", icon: "home" },
      },
      {
        // 人员
        path: "/dashboard/personnel",
        component: () => import("@/views/dashboard/personnel/index.vue"),
        name: "dashboard-personnel",
        meta: { title: "人员", icon: "people" },
      },
      {
        // 业务
        path: "/dashboard/business",
        component: () => import("@/views/dashboard/business/index.vue"),
        name: "dashboard-business",
        meta: { title: "业务", icon: "business" },
      },
      {
        // 监控
        path: "monitor",
        component: () => import("@/views/dashboard/monitor/index.vue"),
        name: "dashboard-monitor",
        meta: { title: "监控", icon: "monitor" },
      },
      {
        // 监控全屏
        path: "monitor-screen",
        component: () => import("@/views/dashboard/monitor-screen/index.vue"),
        name: "dashboard-monitor-screen",
        meta: { title: "监控全屏", icon: "monitor" },
      },
      // {
      //   // 资料
      //   path: "material",
      //   component: () => import("@/views/dashboard/material/index.vue"),
      //   name: "material",
      //   meta: { title: "资料", icon: "material" },
      // },
      {
        // 车间
        path: "/dashboard/workshop",
        component: () => import("@/views/dashboard/workshop/index.vue"),
        name: "dashboard-workshop",
        meta: { title: "车间", icon: "workshop" },
      },
    ],
  },
];

const createRouter = () =>
  new Router({
    mode: "hash", // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: routes,
  });

const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
